import React from 'react';
import { CardContent, Skeleton, Stack } from '@mui/material';

import {
  StyledCard,
  FirstContentRow,
  SecondContentRow,
} from 'components/TaskCard/styles';

const Title = () => <Skeleton
  sx={{ fontSize: '25px' }}
/>;

const Text = (props) => <Skeleton
  sx={{ fontSize: '14px' }} {...props}
/>;

const Badge = () => <Skeleton
  variant='rounded' height='18px' width='54px'
/>;
const Button = () => <Skeleton
  variant='rounded' height='44px'
/>;

const TaskCardSkeleton = () => (
  <StyledCard>
    <CardContent>
      <FirstContentRow>
        <Stack
          spacing='8px'>
          <Title />
          <Stack>
            <Text />
            <Text />
            <Text
              width='60%'
            />
          </Stack>
          <Badge />
        </Stack>
      </FirstContentRow>
      <SecondContentRow>
        <Button />
      </SecondContentRow>
    </CardContent>
  </StyledCard>
);

export default TaskCardSkeleton;
